module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-row', {
    attrs: {
      "gutter": 30
    }
  }, [_c('el-col', {
    attrs: {
      "span": 12,
      "xs": 24
    }
  }, [_c('el-tabs', {
    on: {
      "tab-click": function($event) {
        _vm.selectedAccess = null
      }
    },
    model: {
      value: (_vm.regStatusFilter),
      callback: function($$v) {
        _vm.regStatusFilter = $$v
      },
      expression: "regStatusFilter"
    }
  }, [_c('el-tab-pane', {
    attrs: {
      "name": "none",
      "label": _vm.$t('regStatus.none')
    }
  }), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "name": "pending",
      "label": _vm.$t('regStatus.pending')
    }
  }), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "name": "active",
      "label": _vm.$t('regStatus.active')
    }
  }), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "name": "disabled",
      "label": _vm.$t('regStatus.disabled')
    }
  }), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "name": "inprogress",
      "label": _vm.$t('regStatus.inprogress')
    }
  })], 1), _vm._v(" "), _c('data-table', {
    attrs: {
      "model": _vm.visibleAccessHolders,
      "columns": _vm.extendedColumns,
      "operations": _vm.operations,
      "single-select": ""
    },
    on: {
      "row-click": _vm.accessHolderSelected
    }
  })], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12,
      "xs": 24
    }
  }, [(!!_vm.selectedAccess) ? _c('access-form', {
    attrs: {
      "access": _vm.selectedAccess,
      "disabled": _vm.regStatusFilter === 'inprogress'
    },
    on: {
      "submit": _vm.onSubmit
    }
  }) : _vm._e()], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-41bef03a!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/access/SingleAccess.vue
// module id = 1148
// module chunks = 2